import { PieChartIcon } from './PieChartIcon';
import { BRAND_AFFINITY_LEVEL_PIE_CHART_PERCENTAGE } from './constants';
import { BrandAffinityProps } from './types';
import { BrandAffinityContainer } from './BrandAffinity.styles';

export const BrandAffinity = ({ affinityText, containerLabel, level }: BrandAffinityProps) => {
  return (
    <BrandAffinityContainer data-level={level} data-test={containerLabel}>
      <PieChartIcon percentage={BRAND_AFFINITY_LEVEL_PIE_CHART_PERCENTAGE[level]} />
      {affinityText}
    </BrandAffinityContainer>
  );
};
